import React, {useCallback} from 'react';
import {Input} from '@flixbus/honeycomb-react';
import {useAppDispatch} from '@/Pages/Common/hooks/useAppDispatch';
import {useDebouncedCallback} from '@/hooks/useDebouncedCallback';
import {updateFilter} from '../../../store/slice';

const CalculationNameFilter: React.FC = () => {
  const dispatch = useAppDispatch();

  const handleSelect = useCallback(
    (value: string) => {
      dispatch(
        updateFilter({
          field: 'name',
          value
        })
      );
    },
    [dispatch]
  );

  const [debouncedFn] = useDebouncedCallback(handleSelect, 200);

  return (
    <Input
      label="Cost calculation name"
      id="cost-calculation-name-filter"
      onChange={e => debouncedFn(e.target.value)}
    />
  );
};

export default React.memo(CalculationNameFilter);
